import API from "./lib/api";
import { roomUrl } from "./lib/url";
import { getActiveRestaurantSystemId } from "@/lib/idProvider";


export const getAllRoomApi = async (id) => {
    try {
        const { data } = await API.get( 
            `/floors/${id}/rooms`
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}



export const addRoomApi = async (restaurant_system_id_or_data, roomData) => {
    try {
        let systemId = restaurant_system_id_or_data;
        let payload = roomData;
        if (!roomData && typeof restaurant_system_id_or_data === "object") {
            payload = restaurant_system_id_or_data;
            systemId = getActiveRestaurantSystemId() || localStorage.getItem("restaurant_system_id") || "";
        }
        
        const { data } = await API.post( 
            `${roomUrl}`,
            {...payload, restaurant_system_id: systemId || getActiveRestaurantSystemId()}
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}

export const editRoomApi = async (roomData, id) => {
    console.log(roomData, id)
    try {
        
        const { data } = await API.put( 
            `${roomUrl}/${id}`,
            {...roomData}
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}


export const deleteRoomApi = async (id) => {
    try {
        
        const { data } = await API.delete( 
            `${roomUrl}/${id}`,
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}